// src/lib/ctaTracking.js
// Global CTA tracking via event delegation.
// Goal: ensure the front always calls trackEvent on landing CTAs,
// even when individual buttons don't have explicit onClick handlers.

export function installCtaTracking({ trackEvent, enabled, sendMetaEvent } = {}) {
  if (typeof window === "undefined") return;
  if (window.__tresopilot_ctaTrackingInstalled) return;
  window.__tresopilot_ctaTrackingInstalled = true;

  const isEnabled = () => {
    try {
      return typeof enabled === "function" ? !!enabled() : true;
    } catch {
      return true;
    }
  };

  document.addEventListener(
    "click",
    (e) => {
      try {
        const el = e.target?.closest?.("[data-track='cta'], a, button");
        if (!el) return;
        if (!isEnabled()) return;

        // Use explicit metadata when provided (recommended)
        const explicit = el.getAttribute?.("data-track") === "cta";
        const href = el.getAttribute?.("href") || "";
        const nextPath = el.getAttribute?.("data-next") || href || "";

        // Heuristic: track any CTA to login/register/onboarding/billing, or explicit data-track
        const looksLikeCta =
          explicit ||
          /\/(register|login|onboarding|billing)\b/i.test(nextPath) ||
          /\/(register|login|onboarding|billing)\b/i.test(href);

        if (!looksLikeCta) return;

        const label =
          el.getAttribute?.("data-cta") ||
          el.getAttribute?.("aria-label") ||
          (el.textContent || "").trim().slice(0, 80) ||
          "cta";

        const placement = el.getAttribute?.("data-placement") || "unknown";

        // Fire and forget (do not block navigation)
        void trackEvent?.({
          eventName: "landing_cta_click",
          page: window.location.href,
          source: "landing",
          customData: {
            label,
            placement,
            nextPath,
            id: el.id || null,
            cls: typeof el.className === "string" ? el.className : null,
          },
        });
        
        // Meta CAPI (temps réel) : signal "Lead" sur clic CTA.
        // Cadre légal (Option 2) : on envoie un signal via CAPI même si cookies refusés.
        // Pixel/retargeting reste bloqué sans consentement MARKETING.
        try {
          void sendMetaEvent?.({
            eventName: "Lead",
            requireMarketing: false,
            customData: {
              content_name: "landing_cta_click",
              label,
              placement,
              nextPath,
              href,
            },
            eventSourceUrl: window.location.href,
          });
        } catch (_e) {
          // ignore
        }
      } catch (_err) {
        // keep silent in prod
      }
    },
    true
  );
}
